import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { configuracion } from '../../recursos/config.service';

@Component({
  selector: 'app-promedio-operario',
  templateUrl: './promedio-operario.component.html',
  styleUrls: ['./promedio-operario.component.css']
})
export class PromedioOperarioComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public vecFacultad = []; public vecCarrera = []; public vecPeriodo = []; codUnico: string = '';
  public vecEstudiante = []; public vecParametro = []; public encabezado: string = ''; public vecAjustes = [];
  public selectPeriodo: string = ''; private fechaHoy: string = ''; public vecPostula = [];

  public postProvincia = ''; public postCiudad = ''; public postSexo = ''; public postDiscapacidad = ''; public postPorcentaje = ''; public postDiversidad = ''; public postEtnia = '';
  public postNivel = 0; public postProm = 0; public postAsiste = 0; public postCupo = 0; public postIndice = 0;

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private confMensaje: configuracion,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.encabezado = "Estudiantes con mejores promedios";
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarFacultades(); this.cargarPeriodos(); this.cargarParametros(); this.calculoFecha();
  }
  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarFacultades() {
    this.vecFacultad = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(1, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecFacultad.push({
        codigo: 0, nombre: 'Seleccione una facultad'
      });
      for (let i in res.carrera) {
        this.vecFacultad.push({
          codigo: res.carrera[i]['strCodigo'], nombre: res.carrera[i]['strNombre']
        });
      }
    }
  }
  //FUNCION QUE CARGA TODAS LAS CARRERAS DADA UNA FACULTAD DE LA INSTITUCION
  async cargarCarreras(facultad) {
    this.vecCarrera = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(2, facultad, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecCarrera.push({
        codigo: 0, nombre: 'Todas las carreras', base: 'na', unico: 'na'
      });
      for (let i in res.carrera) {
        this.vecCarrera.push({
          codigo: res.carrera[i]['codCarrera'], nombre: res.carrera[i]['nombCarrera'].replace('.', '(REDISEÑO)'),
          base: res.carrera[i]['strBaseDatos'], unico: res.carrera[i]['carrera_unica']
        });
      }
    }
  }
  //FUNCION PARA DETERMINAR LA BASE DE UNA CARRERA
  async cargarBase(codigo) {
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(5, codigo, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.codUnico = res.carrera[0]['strCodigo']
    }
  }
  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarPeriodos() {
    this.vecPeriodo = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(3, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.selectPeriodo = res.carrera[1]['strCodigo'];
      for (let i in res.carrera) {
        this.vecPeriodo.push({
          codigo: res.carrera[i]['strCodigo'], descripcion: res.carrera[i]['strDescripcion'], inicio: res.carrera[i]['dtFechaInic'], fin: res.carrera[i]['dtFechaFin']
        });
      }
    }
  }
  //FUNCION QUE CARGA LOS PARAMETROS ESTABLECIDOS PARA LAS BECAS
  async cargarParametros() {
    this.vecAjustes = [];
    const resAjuste = await new Promise<any>(resolve =>
      this.srvSelect.gestionOtros(2, 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resAjuste.success) {
      this.vecAjustes = resAjuste.ajustes;
    }
  }
  //OPCIONES PARA GENEARAR EL REPORTE
  generaReporte() {
    if (this.vecParametro[0]['facultad'] == '0')
      this.alerti.error('Debe seleccionar una facultad');
    else {
      if (this.vecParametro[0]['carrera'] == '0')
        this.verReporteFacultad();
      else
        this.verReporteCarrera();
    }
  }
  //GENERAR EL REPORTE POR LA FACULTAD
  async verReporteFacultad() {
    this.cerrarModal();

    this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), localStorage.getItem('perfilAudita'), 'Reporte mejores estudiantes por facultad',
      'Imprimir el reporte de los estudiantes con mejor promedio para las becas de alto rendimiento', 2, 'Cod Facultad - ' + this.vecParametro[0]['facultad'], 1).subscribe(res => {
      });
    this.cargando.abrir(); this.vecEstudiante = [];
    var contObliga = 0; var banObliga = false; var totalNota = 0; var totalAsiste = 0;

    const resFacultad = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(7, this.vecParametro[0]['facultad'], 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resFacultad.success) {
      for (let cont in resFacultad.carrera) {
        //OBTENER TODAS LAS CARRERAS QUE PERTENECEN AL CODIGO UNICO SELECCIONADO
        const resCarreras = await new Promise<any>(resolve =>
          this.srvSelect.gestionCarreras(6, resFacultad.carrera[cont]['carrera_unica'], 'na', 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (resCarreras.success) {
          for (let j in resCarreras.carrera) {

            //DETERMINAR TODAS LAS MATRICULAS VIGENTES EXISTES EN UNA CARRERA 
            const resMatr = await new Promise<any>(resolve =>
              this.srvSelect.gestionMatricula(4, resCarreras.carrera[j]['baseCarrera'], this.vecParametro[0]['periodo'], 'na', 'na').subscribe(translated => {
                resolve(translated)
              }));
            if (resMatr.success) {
              for (let k in resMatr.matricula) {

                //DETERMINA LAS MATERIAS OBLIGATORIAS DICTADAS EN UN DETERMINADO NIVEL
                const resOblig = await new Promise<any>(resolve =>
                  this.srvSelect.gestionMatricula(12, resCarreras.carrera[j]['baseCarrera'], resMatr.matricula[k]['strCodNivel'], resMatr.matricula[k]['strCodPensum'], 'na').subscribe(translated => {
                    resolve(translated)
                  }));

                if (resOblig.success) {
                  contObliga = 0; banObliga = true; totalNota = 0; totalAsiste = 0;
                  while (contObliga < resOblig.matricula.length && banObliga) {//RECORREMOS CADA MATERIA OBLIGATORIA PARA DETEMINAR SI EL ESTUDIANTE TIENE 2DA MATRICULA

                    const resNumMatr = await new Promise<any>(resolve =>
                      this.srvSelect.gestionMatricula(-1, resCarreras.carrera[j]['baseCarrera'], resMatr.matricula[k]['strCodigo'], resOblig.matricula[contObliga]['codMateria'], 'na').
                        subscribe(translated => {
                          resolve(translated)
                        }));
                    if (resNumMatr.success) {
                      totalNota = totalNota + resNumMatr.matricula[0]['bytAcumulado'] + resNumMatr.matricula[0]['bytNota'];
                      totalAsiste = totalAsiste + resNumMatr.matricula[0]['bytAsistencia'];
                    } else {
                      banObliga = false; contObliga = resOblig.matricula.length
                    }
                    contObliga = contObliga + 1;
                  }
                  if (banObliga && (((totalNota * 20) / 40) / contObliga) >= this.vecAjustes[1]['strValor']) {
                    this.vecEstudiante.push({
                      facultad: resCarreras.carrera[j]['nombreFacultad'], carrera: resCarreras.carrera[j]['nombreCarrera'], codEstudiante: resMatr.matricula[k]['strCodigo'],
                      codigo: resMatr.matricula[k]['strCedula'], nombres: resMatr.matricula[k]['strNombres'], apellidos: resMatr.matricula[k]['strApellidos'],
                      nivel: resMatr.matricula[k]['strCodNivel'], sexo: resMatr.matricula[k]['strCodSexo'],
                      asiste: Math.trunc(totalAsiste / contObliga) + '%', nota: (totalNota / contObliga) / 2,
                      codCarrera: resCarreras.carrera[j]['codigoCarrera'], codFacultad: resCarreras.carrera[j]['codigoFacultad'], periodo: this.vecParametro[0]['periodo']
                    });
                  }
                }
              }
            }
          }
        }
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //GENERAR EL REPORTE POR CARRERA
  async verReporteCarrera() {
    this.cerrarModal();

    this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), localStorage.getItem('perfilAudita'), 'Reporte antiguo mejores estudiantes por carrera',
      'Imprimir el reporte antiguo de los estudiantes con mejor promedio para las becas de alto rendimiento', 1, 'Cod Carrera - ' + this.codUnico, 1).subscribe(res => {
      });
    this.postIndice = this.vecPeriodo.findIndex(buscar => buscar.codigo === this.vecParametro[0]['periodo']);

    this.cargando.abrir(); this.vecEstudiante = [];
    var contObliga = 0; var banObliga = false; var totalNota = 0; var totalAsiste = 0;

    const resCodUnico = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(5, this.codUnico, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resCodUnico.success) {
      //OBTENER TODAS LAS CARRERAS QUE PERTENECEN AL CODIGO UNICO SELECCIONADO
      const resCarreras = await new Promise<any>(resolve =>
        this.srvSelect.gestionCarreras(6, resCodUnico.carrera[0]['carrera_unica'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resCarreras.success) {
        for (let j in resCarreras.carrera) {
          //DETERMINAR TODAS LAS MATRICULAS VIGENTES EXISTES EN UNA CARRERA 
          const resMatr = await new Promise<any>(resolve =>
            this.srvSelect.gestionMatricula(4, resCarreras.carrera[j]['baseCarrera'], this.vecParametro[0]['periodo'], 'na', 'na').subscribe(translated => {
              resolve(translated)
            }));
          if (resMatr.success) {

            for (let k in resMatr.matricula) {
              //OBTENEMOS TODAS LAS MATERIAS QUE SE MATRICULA CADA ESTUDIANTE
              const resMaterias = await new Promise<any>(resolve =>
                this.srvSelect.gestionMatricula(13, resCarreras.carrera[j]['baseCarrera'], resMatr.matricula[k]['strCodigo'], this.vecParametro[0]['periodo'], 'na').subscribe(translated => {
                  resolve(translated)
                }));

              if (resMaterias.success) {
                contObliga = 0; banObliga = true; totalNota = 0; totalAsiste = 0;
                while (contObliga < resMaterias.matricula.length && banObliga) {//RECORREMOS CADA MATERIA OBLIGATORIA PARA DETEMINAR SI EL ESTUDIANTE TIENE 2DA MATRICULA

                  if (resMaterias.matricula[contObliga]['bytNumMat'] == 1) {
                    const resNumMatr = await new Promise<any>(resolve =>
                      this.srvSelect.gestionMatricula(7, resCarreras.carrera[j]['baseCarrera'], resMatr.matricula[k]['strCodigo'], resMaterias.matricula[contObliga]['strCodMateria'], 'na').
                        subscribe(translated => {
                          resolve(translated)
                        }));
                    if (resNumMatr.success) {
                      totalNota = totalNota + resNumMatr.matricula[0]['bytAcumulado'] + resNumMatr.matricula[0]['bytNota'];
                      totalAsiste = totalAsiste + resNumMatr.matricula[0]['bytAsistencia'];
                    } else {
                      banObliga = false; contObliga = resMaterias.matricula.length
                    }
                    contObliga = contObliga + 1;
                  } else {
                    banObliga = false; contObliga = resMaterias.matricula.length
                  }
                }
                if (banObliga && (((totalNota * 20) / 40) / contObliga) >= this.vecAjustes[1]['strValor']) {
                  this.vecEstudiante.push({
                    facultad: resCarreras.carrera[j]['nombreFacultad'], carrera: resCarreras.carrera[j]['nombreCarrera'], codEstudiante: resMatr.matricula[k]['strCodigo'],
                    codigo: resMatr.matricula[k]['strCedula'], nombres: resMatr.matricula[k]['strNombres'], apellidos: resMatr.matricula[k]['strApellidos'],
                    nivel: resMatr.matricula[k]['strCodNivel'], sexo: resMatr.matricula[k]['strCodSexo'],
                    asiste: Math.trunc(totalAsiste / contObliga) + '%', nota: (totalNota / contObliga) / 2,
                    codCarrera: resCarreras.carrera[j]['codigoCarrera'], codFacultad: resCarreras.carrera[j]['codigoFacultad'], periodo: this.vecParametro[0]['periodo']
                  });
                }
              }
            }
          }
        }
      }
    }

    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE VER LOS PARAMETROS DEL REPORTE DE MEJORES ESTUDIANTES
  modalModRequisito(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.inicarParametro();
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION PARA ABRIR EL MODAL QUE MUESTRA DATOS DE UN POSTULANTE
  async modalModPostulantes(nameMod, objRol) {
    this.vecPostula = [];
    if (localStorage.getItem('modUser') == 'true') {
      this.inicarParametro();
      this.mr = this.modalService.open(nameMod);

      //CARGAMOS LOS DATOS NECESARIOS PARA ASIGNAR LA BECA AL ESTUDIANTES
      this.vecPostula.push({
        codEstudiante: objRol['codEstudiante'], fecha: this.fechaHoy, idBeca: localStorage.getItem('modBeca'), estado: 3, cedula: objRol['codigo'],
        resolucion: 'PENDIENTE', periodo: this.vecPeriodo[this.postIndice > 0 ? this.postIndice - 1 : this.postIndice]['codigo'], carrera: objRol['codCarrera'],
        facultad: objRol['codFacultad'], nivel: objRol['nivel']
      });
      
      this.postSexo = objRol['sexo'] == 'MAS' ? 'Hombre' : 'Mujer';
      this.postNivel = objRol['nivel']; this.postProm = objRol['nota'];
      this.postAsiste = objRol['asiste']; this.postCupo = 0;

      const resCodUnico = await new Promise<any>(resolve =>
        this.srvSelect.gestionCarreras(5, objRol['codCarrera'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resCodUnico.success) {
        const resCarreras = await new Promise<any>(resolve =>
          this.srvSelect.gestionCarreras(6, resCodUnico.carrera[0]['carrera_unica'], 'na', 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (resCarreras.success) {
          for (let j in resCarreras.carrera) {
            const resAplica = await new Promise<any>(resolve =>
              this.srvSelect.gestionPostulantes(8, this.vecPeriodo[this.postIndice > 0 ? this.postIndice - 1 : this.postIndice]['codigo'],
                resCarreras.carrera[j]['codigoCarrera'], objRol['nivel'], localStorage.getItem('modBeca')).subscribe(translated => {
                  resolve(translated)
                }));
            if (resAplica.success) {
              this.postCupo = this.postCupo + resAplica.postula[0]['totalPostula'];
            }
          }
        }
        this.postCupo = this.vecAjustes[2]['strValor'] - this.postCupo;
      }

      const resProcede = await new Promise<any>(resolve =>
        this.srvSelect.gestionDatosPersonaMaster(1, objRol['codigo'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resProcede.success) {
        this.postCiudad = resProcede.persona[0]['nombCiudad'];
        this.postProvincia = resProcede.persona[0]['nombProvincia'];
      } else {
        this.postCiudad = 'No registra'; this.postProvincia = 'No registra';
      }

      const resDiscapacidad = await new Promise<any>(resolve =>
        this.srvSelect.gestionGruposCentral(13, objRol['codigo'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resDiscapacidad.success) {
        this.postDiscapacidad = resDiscapacidad.consulta[0]['detalle'];
        this.postPorcentaje = resDiscapacidad.consulta[0]['porcentaje'];
      } else {
        this.postDiscapacidad = 'No registra'; this.postPorcentaje = 'No registra';
      }

      const resDiversidad = await new Promise<any>(resolve =>
        this.srvSelect.gestionGruposCentral(14, objRol['codigo'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resDiversidad.success) {
        this.postDiversidad = resDiversidad.consulta[0]['detalle'];
      } else {
        this.postDiversidad = 'No registra';
      }

      const resEtnia = await new Promise<any>(resolve =>
        this.srvSelect.gestionGruposCentral(12, objRol['codigo'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resEtnia.success) {
        this.postEtnia = resEtnia.consulta[0]['detalle'];
      } else {
        this.postEtnia = 'No registra';
      }
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE ASIGNA UNA BECA DE ALTO RENDIMIENTO AL ESTUDIANTE SELECCIONADO
  async asignaBeca() {
    if (this.postCupo > 0) {
      const resPostula = await new Promise<any>(resolve =>
        this.srvSelect.gestionPostulantes(7, this.vecPostula[0]['codEstudiante'], this.vecPostula[0]['periodo'], 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resPostula.success)
        this.alerti.error('El estudiante seleccionado ya tiene una postulación para el período actual')
      else {
        this.alerti.confirm('Está seguro de asignar la beca al estudiante seleccionado?', () => {
          this.aceptaTerminos();
        });
      }
    }
    else
      this.alerti.error('Ya no se admite más postulantes para la carrera y nivel seleccionado');
  }
  //ASIGNA LA BECA AL ESTUDIANTE SELECCIONADO
  aceptaTerminos() {
    this.srvInsert.ingresoGestionBecas(this.vecPostula[0]['codEstudiante'], this.vecPostula[0]['fecha'], this.vecPostula[0]['idBeca'], this.vecPostula[0]['estado'],
      this.vecPostula[0]['resolucion'], this.vecPostula[0]['periodo'], this.vecPostula[0]['carrera'], this.vecPostula[0]['facultad'], this.vecPostula[0]['nivel'],
      'na', 'na', 'na', 'na', 'na', 12).subscribe(res => {
        if (res['becas'] == 'true') {
          this.srvSelect.personaCentralDocumento(this.vecPostula[0]['cedula'].replace('-', '')).subscribe(data => {
            if (data.success) {
              //data.datos['per_email']
              this.enviarCorreo(data.datos['per_nombres'] + " " + data.datos['per_primerApellido'] + " " + data.datos['per_segundoApellido'], data.datos['per_email']);
              this.alerti.success('Beca asignada con éxito');
            }
          });
          this.cerrarModal();
        }
        else
          this.alerti.error("No se puede agregar la postulación. Intente más tarde.");
      });
  }
  //FUNCION QUE PERMITE EL ENVÍO DE CORREOS
  async enviarCorreo(nombres, correo) {
    let contenido = this.confMensaje.bodyMensaje(1,'na','na','na','na','na') + nombres + this.confMensaje.bodyMensaje(7,'na','na','na','na','na');
    this.srvInsert.envioMail('Postulación Alto Rendimiento académico', correo, btoa(contenido)).subscribe(resEnvio => {
      if (resEnvio.correo)
        this.alerti.error("Error al enviar el correo electrónico");
    });
  }
  //FUNCION QUE CARGA TODOS LOS ESTUDIANTES CON LOS MEJORES PROMEDIOS
  async cargarRolesAcitivades() {
    this.vecEstudiante = [];
    this.cargando.abrir();
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPermisos(7, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let i in res.permiso) {
        this.vecEstudiante.push({
          idRol: res.permiso[i]['intRol'], idOpcion: res.permiso[i]['intOpcion'], idActividad: res.permiso[i]['intPadreOpcion'],
          insertar: res.permiso[i]['bitInsertar'] == true ? "SI" : "NO", editar: res.permiso[i]['bitMmodificar'] == true ? "SI" : "NO",
          eliminar: res.permiso[i]['bitEliminar'] == true ? "SI" : "NO", nombRol: res.permiso[i]['rol'],
          nombOpcion: res.permiso[i]['permiso'], nombActividad: res.permiso[i]['actividad'],
          estado: res.permiso[i]['intEstado'] == 1 ? "Activo" : "Inactivo"
        });
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //FUNCION PARA INSTANCIAR EL VECTOR DE PARAMETROS
  inicarParametro() {
    this.vecParametro = [];
    this.vecParametro.push({
      facultad: 0, carrera: 0, periodo: this.selectPeriodo
    })
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
  //FUNCION QUE CALCULA LA FECHA ACTUAL DEL SISTEMA
  calculoFecha() {
    var hoy = new Date();
    var diahoy = hoy.getDate() < 10 ? "0" + hoy.getDate() : hoy.getDate();
    var meshoy = (hoy.getMonth() + 1) < 10 ? "0" + (hoy.getMonth() + 1) : (hoy.getMonth() + 1);
    var aniohoy = hoy.getFullYear();
    this.fechaHoy = aniohoy + "-" + meshoy + "-" + diahoy;
  }
}
